import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector } from '@STORE/index';

import { newVariantModalSlice, NewVariantModalDispatchParams, NewVariantModalState } from '@REDUCERS';

function createNewVariantModalHook() {
    return function useNewVariantModal(equalityFn?: EqualityFn<NewVariantModalState>) {
        const state = useAppSelector((store) => store.newVariantModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: NewVariantModalDispatchParams) => dispatch(newVariantModalSlice.actions.open(params)),
            close: () => dispatch(newVariantModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createNewVariantModalHook();
